/**
 * Parent-side drag reorder handler. Listens for iframe bridge drag events
 * and routes them through section-manager for state management.
 */

import { eventBus } from '../core/events.js';
import { moveSection } from './section-manager.js';

let initialized = false;

/**
 * Wire up toolbar move event listeners. Call once during app init. Sidebar
 * pointer/native drag UI lives in ui/section-list.js; this module only handles
 * the iframe glass-toolbar move-up/down event.
 */
export function initDragReorder() {
  if (initialized) return;
  initialized = true;

  eventBus.on('iframe:section-moved', async ({ instanceId, newIndex }) => {
    if (!instanceId || typeof newIndex !== 'number') return;
    await moveSection(instanceId, newIndex);
  });
}
